import React, { Component } from 'react';
import PropTypes from 'prop-types';
import config from '../../../config';
import Header from '.';

const LEGACY_SECTION_ALIASES = {
  consumers: 'customers',
  suppliers: 'engines',
};

const normalizeDocSearchUrl = (url) => {
  if (!url || typeof window === 'undefined') {
    return url;
  }

  try {
    const isAbsoluteUrl = /^https?:\/\//.test(url);
    const normalizedUrl = new URL(url, window.location.origin);
    const pathParts = normalizedUrl.pathname.split('/');
    const normalizedSection = LEGACY_SECTION_ALIASES[pathParts[1]];

    if (!normalizedSection) {
      return url;
    }

    pathParts[1] = normalizedSection;
    normalizedUrl.pathname = pathParts.join('/');

    return isAbsoluteUrl
      ? normalizedUrl.toString()
      : `${normalizedUrl.pathname}${normalizedUrl.search}${normalizedUrl.hash}`;
  } catch (error) {
    return url;
  }
};

const normalizeDocSearchHit = (hit) => ({
  ...hit,
  url: normalizeDocSearchUrl(hit.url),
  url_without_anchor: normalizeDocSearchUrl(hit.url_without_anchor),
});

/**
 * Connects DocSearch to Header component.
 * See: https://community.algolia.com/docsearch/dropdown.html
 */
class HeaderContainer extends Component {
  componentDidMount() {
    window.docsearch({
      apiKey: config.docsearchApiKey,
      indexName: config.docsearchIndex,
      appId: config.docsearchAppId,
      algoliaOptions: { facetFilters: [`lang:${this.props.locale}`] },
      inputSelector: '#algolia-doc-search',
      transformData: (hits) => hits.map(normalizeDocSearchHit),
    });
  }

  render() {
    return <Header searchId='algolia-doc-search' />;
  }
}

HeaderContainer.propTypes = {
  locale: PropTypes.string.isRequired,
};

export default HeaderContainer;
